import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {LoaderService} from '../shared/loader/service/loader.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.includes('dhocReport')) {
      return next.handle(req);
    }
    this.showLoader();
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.hideLoader();
        }
      }),
      catchError((err: any) => {
        this.hideLoader();
        return throwError(() => err);
      })
    );
  }

  private showLoader(): void {
    this.loaderService.isLoaderOn.next(true);
  }

  private hideLoader(): void {
    this.loaderService.isLoaderOn.next(false);
  }
}
